import BaseModel from '@core/model';

import AdviserRoleEnum from '@constants/enums/adviser/role';
// import BrokerRoleEnum from '@constants/enums/broker/role';
import CompanyRoleEnum from '@constants/enums/company/role';
// import CustodianRoleEnum from '@constants/enums/custodian/role';
import FundManagerRoleEnum from '@constants/enums/fundManager/role';
// import InvesteeRoleEnum from '@constants/enums/investee/role';
// import NomineeRoleEnum from '@constants/enums/nominee/role';
// import ReceivingAgentRoleEnum from '@constants/enums/receivingAgent/role';
// import RegistrarRoleEnum from '@constants/enums/registrar/role';
import GrowthInvestRoleEnum from '@constants/enums/growthInvest/role';
import InvestorRoleEnum from '@constants/enums/investor/role';
import OrganisationTypeEnum from '@constants/enums/organisation/type';
import ProviderRoleEnum from '@constants/enums/provider/role';

import i18n from '@plugins/i18n';

import { Organisation } from '@/models';

export class UserRole extends BaseModel {
    static entity = 'userRole';
    static runSetup = true;

    static fields() {
        return {
            ...super.fields(),
            /** API allows at most one role string per organisation entry (stored as a one-element array). */
            roles: this.attr([]).nullable(),
            type: this.enum(OrganisationTypeEnum).nullable(),
            organisation_id: this.string(null).nullable(),
            organisation: this.belongsTo(Organisation, 'organisation_id')
        };
    }

    setupLogic() {
        const auth = this.Auth();

        if (auth.is_investor || auth.is_provider || auth.is_company) {
            if (!this.type) {
                this.type = auth.organisation_type;
            }

            if (!this.organisation_id) {
                this.organisation_id = auth.organisation_id;
                this.organisation = auth.organisation;
            }
        }
    }

    get is_valid() {
        return Boolean(this.organisation_id && Array.isArray(this.roles) && this.roles.length === 1 && this.roles[0]);
    }

    get computed_name() {
        if (this.is_valid) {
            let name = [];

            if (this.organisation_type) {
                name.push(i18n.t(`enums.organisation_type.${this.organisation_type}`));
            }

            name.push(this.roles.map(r => i18n.t(`enums.user_role.${r}`)).join(', '));

            if (this.organisation) {
                name.push(this.organisation.name);
            }

            return name.join(' - ');
        }
        return i18n.t('user_role');
    }

    get organisation_type() {
        if (this.type && this.type in OrganisationTypeEnum) {
            return this.type;
        }

        if (this.organisation && this.organisation.type in OrganisationTypeEnum) {
            if (this.organisation.name === 'GrowthInvest') {
                return OrganisationTypeEnum.GROWTH_INVEST;
            }
            return this.organisation.type;
        }

        return null;
    }

    set organisation_type(value = null) {
        if (value !== this.type) {
            this.roles = [];
            this.organisation_id = null;
            this.organisation = null;
            //
            this.type = value;
        }
    }

    get all_roles() {
        return {
            ADVISER: Object.values(AdviserRoleEnum),
            INVESTOR: Object.values(InvestorRoleEnum),
            // BROKER: Object.values(BrokerRoleEnum),
            COMPANY: Object.values(CompanyRoleEnum),
            // CUSTODIAN: Object.values(CustodianRoleEnum),
            FUND_MANAGER: Object.values(FundManagerRoleEnum),
            // NOMINEE: Object.values(NomineeRoleEnum),
            PRODUCT_PROVIDER: Object.values(ProviderRoleEnum),
            // RECEIVINGAGENT: Object.values(ReceivingAgentRoleEnum),
            // REGISTRAR: Object.values(RegistrarRoleEnum),
            GROWTH_INVEST: Object.values(GrowthInvestRoleEnum)
        };
    }

    get available_roles() {
        let items = [];

        if (this.organisation_type && this.organisation_type in OrganisationTypeEnum) {
            for (const role of this.all_roles[`${this.organisation_type}`]) {
                items.push({
                    text: i18n.t(`enums.user_role.${role}`),
                    value: role,
                    disabled: false
                });
            }
        }

        return items;
    }

    get can_change_organisation() {
        const auth = this.Auth();

        if (auth.is_provider || auth.is_company) {
            return false;
        }

        return !!this.organisation_type;
    }

    get can_change_roles() {
        return !!this.organisation_type;
    }
}

export default UserRole;
